<template>
	<div class="d-flex align-center justify-center flex-column">
		<div class="w-85">
			<botao-voltar
				class="mb-5"
				label-voltar="voltar para listagem"
				:nome-rota-anterior="rotaListagem"
			></botao-voltar>
			<cabecalho-ata-view></cabecalho-ata-view>
			<pesquisa-itens-view></pesquisa-itens-view>
			<pesquisa-documentos-view></pesquisa-documentos-view>
		</div>
	</div>
</template>
<script>
import { routesNames } from '@/core/constants'
import CabecalhoAtaView from '@/views/pages/ata/pesquisa/acessar/cabecalho/CabecalhoAtaView.vue'
import PesquisaItensView from '@/views/pages/ata/pesquisa/acessar/itens/PesquisaItensView.vue'
import PesquisaDocumentosView from '@/views/pages/ata/pesquisa/acessar/documentos/PesquisaDocumentosView.vue'

export default {
	name: 'acessar-ata-view',
	components: { PesquisaItensView, CabecalhoAtaView, PesquisaDocumentosView },
	data() {
		return {
			rotaListagem: routesNames.ATA.ATA_VIEW,
		}
	},
	async mounted() {},
	methods: {},
}
</script>
<style scoped lang="stylus">
.w-85
	width: 85%

.w-90
	width: 90%
</style>
